<template>
    <div v-if="me" class="user-login-info">
        <div class="user-login-info__wrap">
            <div class="user-login-info__left">
                <span class="font-size-16 font-size-md-18 font-size-lg-22"><b>{{ me.name }}</b>님<br class="d-lg-none"/> 반갑습니다.</span>
            </div>
            <div class="user-login-info__right font-size-14 font-size-md-18 text-right">
                <v-row no-gutters justify-md="end">
                    <v-col cols="12" md="auto">
                        <span>캐시잔액 : <b class="font-size-18 font-size-md-22 secondary--text">{{ me.cash.format() }}</b>원</span>
                    </v-col>
                    <v-col cols="auto" class="d-none d-md-block">
                        <v-divider vertical class="mx-28px" style="max-height:14px; min-height:14px; border-color:#999;"/>
                    </v-col>
                    <v-col cols="12" md="auto">
                        <span>포인트 잔액 : <b class="font-size-18 font-size-md-22 secondary--text">{{ me.point.format() }}</b>원</span>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data(){
        return { me: null }
    },
    mounted(){
        if(this.logon) this.search();
    },
    methods: {
        async search(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        }
    },
    computed: {
        logon(){ return !!this.$store.state.accessToken }
    },
    watch: {
        logon(){
            if(this.logon) this.search();
        }
    }

}
</script>

<style scoped>
.user-login-info{
    position: relative;
    z-index: 2;
    height: 80px;
}
.user-login-info__wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.user-login-info__left,
.user-login-info__right{
    padding: 14px;
}
.user-login-info__left{
    display: flex;
    align-items: center;
    width: 37.5%;
    height: 100%;
    background: #cfcfd7;
}
.user-login-info__right{
    display: flex;
    align-items: center;
    width: calc(100% - 37.5%);
    height: 100%;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .user-login-info{
        border-radius: 24px 24px 0 0;
        background-color: rgba(255,255,255,.8);
        margin-top: -80px;
    }
    .user-login-info__left,
    .user-login-info__right{
        width:50%;
    }
    .user-login-info__left{
        background-color: transparent;
        padding-left:40px;
    }
    .user-login-info__right{
        padding-right:40px;
    }
}
@media (min-width:1200px){
}
</style>